import { render, staticRenderFns } from "./generalInfo.vue?vue&type=template&id=60a76046&"
import script from "./generalInfo.vue?vue&type=script&lang=ts&"
export * from "./generalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports